import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
//icons
import { IoIosInformationCircleOutline } from "react-icons/io";
//api
import { createSlider, editSlider } from 'api/sliders';
//herlpers
import { capitalizeText, validateUrl } from 'helpers';
//components
import ModalCustom from 'components/backoffice/modals/ModalCustom';
import FooterModal from 'components/backoffice/modals/FooterModal';
import { SelectInputCustom } from 'components/input';
import Input from 'components/backoffice/customInput/index';
import SearchProduct from 'components/backoffice/customInput/SearchProduct';
import CustomCheckbox from 'components/backoffice/customCheckbox';
import CustomRadioButton from 'components/backoffice/customRadiobutton';


const SliderModal = ({ object, type, show, setShow, onUpdateTable }) => {
  const { t } = useTranslation(['backoffice']);
  const { setTitle } = useOutletContext()

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [sliderElement, setSliderElement] = useState({
    type_str: '',
    portada: '',
    active: false,
    outer_url: '',
  });
  const [itemProduct, setItemProduct] = useState(null);
  const [fieldRequired, setFieldRequired] = useState(false);
  const [typeSlider, setTypeSlider] = useState(type === 'create' && 'Product');

  const sliderCategories = [
    { id: 'home', value: t('home') },
  ];

  useEffect(() => {
    if (Object.keys(object).length > 0) {
      setSliderElement({
        type_str: object.type_str || '',
        portada: object.portada,
        active: object.active || false,
        outer_url: object.outer_url || '',
      });
      fetch(object.portada)
        .then((response) => response.blob())
        .then((blob) => {
          const name = object.portada.split('?')[0].split('/').pop()
          const file = new File([blob], name, { type: `image/${name.split('.')[1]}` });
          if (object.type_str === 'books') object.type_str = 'book'
          setSliderElement({
            type_str: object.type_str || '',
            portada: file,
            active: object.active || false,
            outer_url: object.outer_url || '',
          });
        })
        .catch((error) => {
          console.error('Error al obtener la imagen:', error);
        });
      setItemProduct(object?.product ? object.product : null);
      setTypeSlider(object?.product ? 'Product' : 'OuterLink')
    }
  }, [object]);


  useEffect(() => {
    if (show) {
      if (type === 'create') {
        setTitle(t('createslider'));
      } else {
        setTitle(t('edit', {title:capitalizeText(object?.product?.titulo)}));
      }
    }
  }, [show, type, object,setTitle]);

  const onSuccess = () => {
    setSliderElement({});
    setShow(false);
    onUpdateTable(sliderElement);
  };

  const onCreate = async () => {
    var formData = new FormData();
    if (sliderElement.portada === '' ||
      sliderElement.portada === undefined ||
      sliderElement?.type_str === '' ||
      ((!itemProduct && sliderElement?.outer_url === '') || (typeSlider === 'OuterLink' && !validateUrl(sliderElement.outer_url)))) {
      setFieldRequired(true);
      return;
    } else {
      setFieldRequired(false);
      formData.append('portada', sliderElement.portada);
      formData.append('producto', itemProduct?.id || '');
      formData.append('type_str', sliderElement.type_str);
      formData.append('outer_url', sliderElement.outer_url || '');
    }
    formData.append('active', sliderElement.active);

    const { data, status } = await createSlider(formData);
    if (status === 201) {
      toast.success(t('creadocorrectamente'));
      setSliderElement({});
      setItemProduct({});
      onSuccess();
    } else {
      toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      setErrors(data);
    }
  };

  const validate = typeof sliderElement.portada === 'string' && type === 'edit';

  const onUpdate = async () => {
    var formData = new FormData();
    if (sliderElement.portada === '' ||
      sliderElement.portada === undefined ||
      sliderElement?.type_str === '' ||
      ((!itemProduct && sliderElement?.outer_url === '') || (typeSlider === 'OuterLink' && !validateUrl(sliderElement.outer_url)))) {
      setFieldRequired(true);
      return;
    } else {
      setFieldRequired(false);
      formData.append('portada', sliderElement.portada);
      formData.append('producto', itemProduct?.id || '');
      formData.append('type_str', sliderElement.type_str);
      formData.append('outer_url', sliderElement.outer_url || '');
    }
    formData.append('active', sliderElement.active);

    const { data, status } = await editSlider(object?.id, formData);
    if (status === 200) {
      toast.success(t('editadocorrectamente'));
      onSuccess();
    } else {
      toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      setErrors(data);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    if (type === 'create') {
      onCreate();
    } else {
      onUpdate();
    }
    setLoading(false);
  };

  const handleSliderType = (type) => {
    if (type === 'Product') {
      setTypeSlider('Product');
      setSliderElement((prev) => ({ ...prev, outer_url: '' }));
    } else {
      setTypeSlider('OuterLink');
      setItemProduct(null);
    }
  };

  const handleCheckboxChange = (e) => {
    setSliderElement((prev) => ({
      ...prev,
      active: e.target.checked,
    }));
  };

  const handleClose = () => {
    setShow(false)
    setTitle(t('sliders'))
  }

  const tooltip = (
    <Tooltip id="tooltip">
      <p>{t('messageTooltip')}<strong>6:1</strong>.</p>
    </Tooltip>
  );

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title={t(type === 'create' ? 'createslider' : 'editslider')}
      footer={<FooterModal onCancel={handleClose} onSave={handleSave} loading={loading} />}
    >
      <div>
        <SelectInputCustom
          choices={sliderCategories}
          label={`${t('category')}`}
          placeholder={t('select')}
          value={sliderElement?.type_str || ''}
          selectClassName='mb-0'
          onCheckedItem={(value) => {
            setSliderElement((prev) => ({ ...prev, type_str: value }));
          }}
        />
        {(fieldRequired && sliderElement.type_str === '') && <p className="text-danger m-0">{t('camporequerido')}</p>}
      </div>

      {type === 'create' && <Form.Label className="mt-3">{t('sliderType')}</Form.Label>}
      <div className={type === 'create' ? "d-flex flex-column border-grey" : "d-flex flex-column"}>
        {type === 'create' && <div className="d-flex gap-3">
          <CustomRadioButton
            label={t('producto')}
            name='typeSlider'
            defaultChecked
            onChange={() => handleSliderType('Product')}
            className="mt-0 align-items-center mx-3"
          />
          <CustomRadioButton
            label={t('externalLink')}
            name='typeSlider'
            onChange={() => handleSliderType('OuterLink')}
            className="mt-0 align-items-center"
          />
        </div>}

        <div className={type === 'create' && 'px-3'}>
          {typeSlider === 'Product' || (type === 'edit' && itemProduct) ? (
            <div className={type === 'create' && 'pb-3'}>
              <SearchProduct
                fields="id,title,ean"
                showLabel={t('producto')}
                filterBy="titulo,ean"
                placeholder={t('searchByEanTitle')}
                onSelected={(product) => {
                  setItemProduct(product);
                }}
                defaultArticle={itemProduct}
              />
            </div>
          ) : (typeSlider === 'OuterLink' || type === 'edit') && (
            <div className="mt-2">
              <Input
                label="Link"
                placeholder="http://"
                value={sliderElement?.outer_url}
                onChange={(e) => setSliderElement((prev) => ({ ...prev, outer_url: e }))}
                className={`m-0 h-38 ${type === 'create' && 'mb-3'}`}
              />
            </div>
          )}
        </div>
      </div>
      {(fieldRequired && (sliderElement.outer_url === '' && !itemProduct)) &&
        <p className="text-danger m-0">{t('camporequerido')}</p>}
      {(fieldRequired && (typeSlider === 'OuterLink' && !validateUrl(sliderElement.outer_url) && sliderElement.outer_url !== '')) &&
        <p className="text-danger m-0">{t('Invalida')}</p>}
      <CustomCheckbox
        label={t('activo')}
        checked={sliderElement?.active}
        onChange={handleCheckboxChange}
      />
      <div>
        <OverlayTrigger placement="top" overlay={tooltip}>
          <div className="container-icon-info">
            <IoIosInformationCircleOutline color="#69f853" size={22} className="icon-info" />
          </div>
        </OverlayTrigger>
        <Input
          type="file"
          dropFileMsg={t('dropFile')}
          label={t('imagen')}
          placeholder={t('selectImg')}
          accept="image/*"
          value={sliderElement.portada}
          className='mb-0'
          onChange={(value) => {
            setSliderElement((prev) => ({ ...prev, portada: value }));
          }}
        />
      </div>
      {(fieldRequired && (sliderElement.portada === '' || sliderElement.portada === undefined)) && <p className="text-danger m-0">{t('camporequerido')}</p>}
      {sliderElement?.portada?.name && (
        <img className="w-100 h-auto mt-3" src={URL.createObjectURL(sliderElement.portada)} alt={`Sliderphoto-${itemProduct?.title}`} />
      )}
      {validate && <img className="w-100 h-auto mt-3" src={sliderElement.portada} alt={`Sliderphoto-${itemProduct?.title}`} />}
    </ModalCustom>
  );
};

export default SliderModal;
